<template>
  <v-main>
    <v-container grid-list-md>
      <v-layout row wrap>
        <customer-dashboard v-if="$auth.check('ROLE_MANAGER') || $auth.check('ROLE_USER')"/>
        <staff-dashboard v-if="$auth.check('ROLE_ADMIN') || $auth.check('ROLE_MODERATOR')"/>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
  const CustomerDashboard = () => import('../components/dashboard/CustomerDashboard');
  const StaffDashboard = () => import('../components/dashboard/StaffDashboard');

  export default {
    name: 'Dashboard',
    components: {
      CustomerDashboard, StaffDashboard,
    },
    data() {
      return {};
    },
  };
</script>
